import { useQuery } from '@tanstack/react-query'
import { fetchLowStockRestockCount } from '../lib/stockAlerts'

// Count of active products at/below their reorder threshold (or out of stock) —
// the same set the `/inventory/low-stock` view lists, so the Trading low-stock
// attention badge and that page reconcile. Gate with `enabled` for users who
// can't see the Low Stock page.
export function useLowStockCount(tid: string, enabled = true) {
  return useQuery<number>({
    queryKey: ['low-stock-count', tid],
    enabled: !!tid && enabled,
    staleTime: 60 * 1000,
    refetchOnWindowFocus: true,
    queryFn: () => fetchLowStockRestockCount(tid),
  })
}
